import { motion } from "framer-motion";

const POINTS = [
  { title: "Professional & Reliable", text: "Punctual turnouts with clear communication across South Yorkshire." },
  { title: "High Quality Results", text: "Industrial rotary washers and biocide treatments that last." },
  { title: "Fully Insured", text: "Complete peace of mind for residential and commercial premises." },
  { title: "Free Quotes", text: "Fast, honest pricing with no hidden charges or obligations." },
];

export default function WhyUs() {
  return (
    <section id="why-us" className="bg-[#070b12] text-[#f0f4f8] py-24 md:py-32 border-b border-[#1e9bff]/15" data-testid="why-us-section">
      <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5 min-w-0">
          <span className="text-xs font-mono-lbl uppercase tracking-[0.2em] text-[#1e9bff] block mb-2">Our Standard</span>
          <h2 className="font-display uppercase text-white text-[clamp(32px,4vw,52px)] leading-none mb-6">
            Why Choose SY Exterior
          </h2>
          <p className="text-sm text-[#93b4d4] mb-8">
            We combine industrial equipment with meticulous local service to protect and transform properties across South Yorkshire.
          </p>
          <div className="p-6 rounded-2xl bg-[#0b1322] border border-[#1e9bff]/30">
            <span className="text-xs font-mono-lbl text-[#1e9bff] block mb-1 uppercase tracking-widest">Customer Protection</span>
            <p className="text-white text-base font-semibold">Fully Insured</p>
          </div>
        </div>
        <div className="lg:col-span-7 min-w-0 grid grid-cols-1 sm:grid-cols-2 gap-4">
          {POINTS.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.45, delay: i * 0.1 }}
              className="p-6 rounded-xl bg-[#0c1626] border border-white/10 hover:border-[#1e9bff]/50 transition-colors"
              data-testid={`why-us-tick-${i + 1}`}
            >
              <div className="w-8 h-8 rounded-full bg-[#1e9bff]/20 text-[#1e9bff] flex items-center justify-center font-bold mb-4">✓</div>
              <h3 className="font-display uppercase text-xl text-white mb-2">{p.title}</h3>
              <p className="text-xs text-[#93b4d4]">{p.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
